import {TransformQuantity} from "@/core/interfaces/ProductPrices";
import {StripePrice} from "@/stripe/interfaces";

export default function () {
    /**
     * Compute the starting price from a prices array.
     *
     * @param {StripePrice[]} prices - The prices array.
     */
    const startingReadablePrice = (prices: StripePrice[]): string => {
        if (!prices?.length) {
            return "";
        }

        const priceIndex = prices.findIndex(price => price.is_default);
        if (priceIndex !== -1) {
            return readablePrice(prices[priceIndex]);
        }

        return readablePrice(prices[0]);
    };

    /**
     * Get a human readable price from stripe price.
     *
     * @param {Price} price - The stripe price.
     *
     * @return {string}
     */
    const readablePrice = (price: StripePrice): string => {
        const value = price.unit_amount / 100;

        return `${value.toFixed(2)}€ ${getRecurringSuffix(price.recurring)}${getTransformQuantityLabel(price.transform_quantity)}`;
    };

    /**
     * Get the recurring suffix.
     *
     * @param {{interval: string, interval_count: number}} recurring
     * @return {string}
     */
    const getRecurringSuffix = (recurring?: { interval: string; interval_count: number }): string => {
        if (!recurring?.interval || !recurring?.interval_count) {
            return "";
        }

        const interval_count = recurring?.interval_count > 1 ? recurring.interval_count + " " : "";
        const symbol = recurring?.interval_count === 1 ? " / " : " tous les ";

        return `${symbol}${interval_count}${readableInterval(recurring.interval)}`;
    };

    /**
     * Get a readable interval.
     *
     * @param {string} interval
     * @return {string}
     */
    const readableInterval = (interval: string): string => {
        switch (interval) {
            case "month":
                return "mois";
            case "year":
                return "an";
            default:
                return "";
        }
    };

    /**
     * Get the transform quantity label.
     *
     * @param {TransformQuantity} transformQuantity
     * @return {string}
     */
    const getTransformQuantityLabel = (transformQuantity?: TransformQuantity): string => {
        if (!transformQuantity) {
            return "";
        }

        return `pour ${transformQuantity.divide_by} unité`;
    };

    return {
        getRecurringSuffix,
        readablePrice,
        startingReadablePrice,
    };
}